import { action } from 'easy-peasy';
import { IActionSetCrisisAllocations } from '../types';

const setCrisisAllocation: IActionSetCrisisAllocations = action((state, payload) => {
  state.current = payload;
});

export default setCrisisAllocation;
